import { ChangeDetectionStrategy, Component, input, output } from '@angular/core'
import { HeaderComponent } from '@shared/components/header/header.component'
import { TemplateDirective } from '@shared/directives/mcm-template.directive'
import { ButtonComponent } from '@shared/components/button/button.component'
import { TranslatePipe } from '@ngx-translate/core'

@Component({
  selector: 'mcm-metric-detail-header',
  templateUrl: './metric-detail-header.component.html',
  styleUrls: ['./metric-detail-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [HeaderComponent, TemplateDirective, ButtonComponent, TranslatePipe]
})
export class MetricDetailHeaderComponent {
  readonly title = input<string>(undefined)
  readonly closeModal = output<void>()
}
